/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";

export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'single',
    profile: {
        locale: 'nl-nl',
        currency: 'EUR',

        p_name_col_name: 'Name',
        p_description_col_name: 'Description',


        searchConfiguration: 'default_p_desc',

        taxonomy_builder_only_n_cats: true,
        allowIncompleteTaxonomy: true,
        hideRepeatingLabels: true,

        disableSupplierNormalizationAiModel: true,
        parentSupplierAltName: 'Normalized Supplier',

        hideCards: [
            'koi-ppv',
            'koi-spend-concentration',
        ],
        showCards: [
            'contract-explorer',
            'payment-terms',
        ],

        disabledCards: [
        ],

        showSupplierIdInAdvDashboard: true,
        showSupplierIdInCategorization: true,
        showSupplierIdInSupplierNormalization: true,

        synergyDashboardShowBusinessUnits: true,
        showBusinessUnitInSupplierNormalization: true,

        showL4InOpportunityDashboard: true,

        enableProcChat: true,
        enableGoldenRecord: true,
        enableSavingInitiativeTracker: true,
    },
}
